import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../Core/Components/CustomButton";
import usePermission from "../../Core/hooks/usePermission";
import { PERMISSIONS } from "../Login/constants";
import useHeaderItems from "./useHeaderItems";

const Buttons = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get("tab");

  const hasCommodityAddPermission = usePermission([PERMISSIONS.RATE_ADD]);

  const hasEnergyAddPermission = usePermission([PERMISSIONS.RATE_ADD]);

  if (selectedTab === "commodity") {
    return (
      <div>
        {hasCommodityAddPermission && (
          <button
            type="button"
            className="px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
            onClick={() => navigate("/add-commodity")}
          >
            <div className="flex item-center gap-x-2">
              <img src="/assets/icons/add.svg" alt="" />
              <p className="font-poppins text-xs leading-4.5 font-medium text-background-white">
                Add Commodity
              </p>
            </div>
          </button>
        )}
      </div>
    );
  }

  if (selectedTab === "energy") {
    return (
      <div>
        {hasEnergyAddPermission && (
          <button
            type="button"
            className="px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
            onClick={() => navigate("/add-energy-rate")}
          >
            <div className="flex item-center gap-x-2">
              <img src="/assets/icons/add.svg" alt="" />
              <p className="font-poppins text-xs leading-4.5 font-medium text-background-white">
                Add Energy Rate
              </p>
            </div>
          </button>
        )}
      </div>
    );
  }

  if (selectedTab === "agri-tech") {
    return (
      <div>
        {hasEnergyAddPermission && (
          <button
            type="button"
            className="px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
            onClick={() => navigate("/add-agri-tech-rate")}
          >
            <div className="flex item-center gap-x-2">
              <img src="/assets/icons/add.svg" alt="" />
              <p className="font-poppins text-xs leading-4.5 font-medium text-background-white">
                Add Commission Rate
              </p>
            </div>
          </button>
        )}
      </div>
    );
  }

  return <div />;
};

const Header = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const headerButtons = useHeaderItems().filter((item) => item.hasPermission);

  const selectedTab = searchParams.get("tab");

  const onTabClick = (item) => {
    searchParams.set("tab", item.text.toLowerCase());
    setSearchParams(searchParams);
  };

  return (
    <div className="px-6 py-3.5 flex items-center justify-between border-b bg-background-white">
      <div className="flex items-center gap-x-6">
        {headerButtons.map((item) => {
          const selected = selectedTab === item.text.toLowerCase();

          return (
            <Button
              key={item.id}
              colors={selected ? "primary" : "white"}
              width={item.width}
              padding={item.padding}
              modifier="shadow"
              onClick={() => onTabClick(item)}
            >
              <div>{item.text}</div>
            </Button>
          );
        })}
      </div>

      <Buttons />
    </div>
  );
};

export default Header;
